import { render, staticRenderFns } from "./Bins.vue?vue&type=template&id=01403382&scoped=true"
import script from "./Bins.vue?vue&type=script&lang=js"
export * from "./Bins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01403382",
  null
  
)

export default component.exports